import {
  apiIntegracion,
  bibliotecaDocs,
  centroNotificaciones,
  firmaColaborativa,
  firmaElectronica,
  firmaNunaExpress,
  NunaSignPdf,
  personalizaFirma,
} from 'assets'
import { FunctionalitiesType } from 'types/functionalities.type'

const whatsappLink = process.env.REACT_APP_WHATSAPP_LINK!

export const FUNCTIONALITIES_DATA_CONST: FunctionalitiesType[] = [
  {
    id: 0,
    title: 'Firma PDF con Nuna Sign',
    description: `Firma documentos en línea, conecta personas, cierra acuerdos con nuestra plataforma.`,
    description2: `Impulsa tu productividad. Sectores donde puedes utilizar Nuna Sign: `,
    bullets: [
      'Telecomunicaciones',
      'Salud',
      'Trámites personales',
      'Aduanas',
      'Jurídico legal',
      'Financiero',
      'Recursos Humanos',
      'Banca y Fintech',
    ],
    image: NunaSignPdf,
    buttonText: 'COMIENZA GRATIS',
    buttonLink: whatsappLink,
  },
  {
    id: 1,
    title: 'Personaliza tu firma',
    description: 'Tu firma habla de ti, haz que cada documento lleve tu estilo, tu firma.',
    bullets: [],
    image: personalizaFirma,
    buttonText: 'COMIENZA GRATIS',
    buttonLink: whatsappLink,
  },
  {
    id: 2,
    title: 'Firma electrónica',
    description:
      'Tu firma electrónica en minutos y autorizada por ARCOTEL cumpliendo todos los estándares legales. Elige la vigencia que se  ajuste a ti, desde 7 días hasta 4 años. Realiza tu compra con nosotros vía Online o WhatsApp, te acompañamos durante todo el proceso. Por tu compra puedes obtener los siguientes beneficios adicionales: ',
    bullets: [
      'Firma PDF gratis con Nuna Sign',
      'Licencias gratis de facturación electrónica por temporada',
    ],
    image: firmaElectronica,
    buttonText: 'COMIENZA GRATIS',
    buttonLink: whatsappLink,
  },
  {
    id: 3,
    title: 'Firma colaborativa',
    description:
      'Como una sinfonía bien dirigida, cada firma llega en el momento exacto. Sube uno o varios documentos, invita a tus firmantes y define el flujo en segundos. Nuna Key se encarga de acompañarte en todo el proceso, notificándote en tiempo real el avance de cada firma, para que nunca pierdas el compás.',
    bullets: [],
    image: firmaColaborativa,
    buttonText: 'COMIENZA GRATIS',
    buttonLink: whatsappLink,
  },
  {
    id: 4,
    title: 'Centro de notificaciones',
    description:
      'Todos tus procesos siempre bajo tu control, te comunicamos de manera oportuna con nuestras alertas predefinidas y ahora con NunaKey también puedes configurar tus recordatorios cuando tú lo necesites.',
    bullets: [
      'Vigencia de documentos',
      'Caducidad de firma electrónica',
      'Documentos pendientes de firmar',
      'Alertas Personalizadas',
    ],
    image: centroNotificaciones,
    buttonText: 'COMIENZA GRATIS',
    buttonLink: whatsappLink,
  },
  {
    id: 5,
    title: 'Biblioteca de documentos',
    description:
      'No empieces desde cero, con Nuna Key tienes a tu alcance una completa biblioteca de documentos prediseñados listos para usar. Crea tu propia biblioteca personalizada; guarda, edita y organiza tus documentos, plantillas o formatos más usados.',

    bullets: ['Contratos legales', 'Acuerdos', 'Actas', 'Compromisos'],
    image: bibliotecaDocs,
    buttonText: 'COMIENZA GRATIS',
    buttonLink: whatsappLink,
  },
  {
    id: 6,
    title: `Api de
    integración`,
    description:
      'Integramos todas las funcionalidades y servicios de NunaKey con tu sistema; Nunakey cuenta con una API que te permitirá automatizar, gestionar y controlar tus procesos con una integración personalizada, segura y lista para escalar tu negocio. ',
    bullets: [],
    image: apiIntegracion,
    buttonText: 'COMIENZA GRATIS',
    buttonLink: whatsappLink,
  },
  {
    id: 7,
    title: `Firma sin firma
    con Nuna Express`,
    description:
      'Sin una firma electrónica previa ahora puedes firmar varios documentos con plena validez legal, verificamos tu identidad mediante un proceso biométrico en línea y firma en tiempo récord con tu certificado digital de un solo uso. Con nuestra API podemos integrar Nuna Express en tus sitemas.',
    bullets: [],
    image: firmaNunaExpress,
    buttonText: 'COMIENZA GRATIS',
    buttonLink: whatsappLink,
  },
]
